import React, { PureComponent } from "react";
import ReactWOW from "react-wow";

class Logo extends PureComponent {
  render() {
    return (
      <ReactWOW animation="fadeInUp" delay="0.1s">
        <div className="col-md-3 col-6">
          <a
            href={this.props.link}
            target="_blank"
            rel="noopener noreferrer"
            className="link"
          >
            <img
              src={"images/partners/" + this.props.image}
              alt={this.props.name}
              className="img-logo"
            />
            <p className="name">{this.props.name}</p>
          </a>
        </div>
      </ReactWOW>
    );
  }
}

const Partners = ({ Message: msg }) => (
  <section id="partners" className="white">
    <div className="container">
      <div className="section-title">
        <h2>{msg.partners}</h2>
      </div>
      <h5>{msg.organized}</h5>
      <div className="row justify-content-center">
        <div className="col-md-4 col-6">
          <a
            href={msg.organizedData[0].link}
            target="_blank"
            rel="noopener noreferrer"
            className="link"
          >
            <img
              src={"images/partners/" + msg.organizedData[0].image}
              alt="shopee"
              className="img-logo shopee"
            />
            <p className="name">{msg.organizedData[0].name}</p>
          </a>
        </div>
      </div>
      <h5>{msg.govPartner}</h5>
      <div className="row justify-content-center">
        {msg.govPartnerData.map(it => {
          return (
            <Logo
              key={it.link}
              name={it.name}
              image={it.image}
              link={it.link}
            />
          );
        })}
      </div>
      <h5>{msg.mediaPartner}</h5>
      <div className="row justify-content-center">
        <Logo
          name={msg.mediaPartnerData[0].name}
          image={msg.mediaPartnerData[0].image}
          link={msg.mediaPartnerData[0].link}
        />
      </div>
      <h5>{msg.trainingPartners}</h5>
      <div className="row justify-content-center">
        {msg.trainingPartnersData.map(it => {
          return (
            <Logo
              key={it.link}
              name={it.name}
              image={it.image}
              link={it.link}
            />
          );
        })}
      </div>
      <h5>{msg.universityPartners}</h5>
      <div className="row justify-content-center">
        {msg.universityPartnersData.map(it => {
          return (
            <Logo
              key={it.link}
              name={it.name}
              image={it.image}
              link={it.link}
            />
          );
        })}
      </div>
      <h5>{msg.techPartners}</h5>
      <div className="row justify-content-center">
        {msg.techPartnersData.map(it => {
          return (
            <Logo
              key={it.link}
              name={it.name}
              image={it.image}
              link={it.link}
            />
          );
        })}
      </div>
      <h5>{msg.diversityPartners}</h5>
      <div className="row justify-content-center">
        {msg.diversityPartnersData.map(it => {
          return (
            <Logo
              key={it.link}
              name={it.name}
              image={it.image}
              link={it.link}
            />
          );
        })}
      </div>
      <h5>{msg.supportPartners}</h5>
      <div className="row justify-content-center">
        {msg.supportPartnersData.map(it => {
          return (
            <Logo
              key={it.link}
              name={it.name}
              image={it.image}
              link={it.link}
            />
          );
        })}
      </div>
    </div>
  </section>
);

export default Partners;
